/*
quiz-form.validate.js

validates a Shopify form using the jQuery Validate plugin
*/

$().ready(function() {
  // validate form on keyup and submit
  $("#quizForm").validate({
    submitHandler: function(form, event) {
      event.preventDefault();
      showResults();
    },
    errorPlacement: function(error, element) {
      error.insertBefore(element);
    },
    rules: {
      "sins": {
        required: true
      },
      "drugs": {
        required: true
      },
      "swear": {
        required: true
      },
      "minor": {
        required: true
      },
      "church": {
        required: true
      },
      "donate": {
        required: true
      },
      "deeds": {
        required: true
      },
      "lie": {
        required: true
      }
    }
  });
});
$.validator.messages.required = "Don’t forget to answer this question";